// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4de3c46b","498":"ff7a9426","703":"8ab13c19","787":"69754abb"}[chunkId] + ".chunk.js";
};